import React from "react";
import NavPublicUser from "../navbarPublicUser"
import Footer from "../Footer";
import PubUserBody from "../pubuserbody";
import PubUserPro from "../PubUsrPro";
import OrderPage from "../OrderPage";
export default function PublicUserPage(){


return(
<div>

    <NavPublicUser />
     <div data-aos="fade-up" data-aos-delay="0">
        <PubUserBody />
    </div>

    <div data-aos="fade-up" data-aos-delay="100">
        <OrderPage />
    </div>

    <div data-aos="fade-up" data-aos-delay="200">
        <PubUserPro />
    </div>
    <Footer  /> 
</div>

)


}